(function () {
  'use strict';

  var CFG     = window.GLP1_CONFIG || {};
  var Q_PAGES = [];
  var TRIAGE  = [];

  var answers = {};
  var stack   = [0];
  var busy    = false;

  // ── Expression evaluator ────────────────────────────────────────────────
  function evalIf(expr) {
    if (!expr) return true;
    try {
      return !!new Function('$',
        '"use strict";try{return(' + expr + ');}catch(e){return false;}'
      )(answers);
    } catch (_) {
      return false;
    }
  }

  // ── Page helpers ────────────────────────────────────────────────────────
  function cur() { return stack[stack.length - 1]; }

  function nextFrom(idx) {
    for (var i = idx + 1; i < Q_PAGES.length; i++) {
      if (evalIf(Q_PAGES[i].showIf)) return i;
    }
    return -1;
  }

  function visibleList() {
    var out = [];
    for (var i = 0; i < Q_PAGES.length; i++) {
      if (stack.indexOf(i) !== -1 || evalIf(Q_PAGES[i].showIf)) out.push(i);
    }
    return out;
  }

  // ── Hard-stop detection ─────────────────────────────────────────────────
  function getHardStop() {
    var qs = Q_PAGES[cur()].questions || [];
    for (var qi = 0; qi < qs.length; qi++) {
      var q = qs[qi];
      if (q.showIf && !evalIf(q.showIf)) continue;

      if (q.hardStopIf && evalIf(q.hardStopIf)) {
        return q.hardStopMessage || 'This online pathway is not suitable at this time.';
      }

      var val  = answers[q.fieldName];
      var opts = q.options || [];
      for (var oi = 0; oi < opts.length; oi++) {
        var opt = opts[oi];
        if (!opt.isHardStop) continue;
        if (q.type === 'radio' && val === opt.value) return opt.hardStopMessage;
        if (q.type === 'checkbox' && Array.isArray(val) && val.indexOf(opt.value) !== -1)
          return opt.hardStopMessage;
      }
    }
    return null;
  }

  // ── Triage routing ──────────────────────────────────────────────────────
  function doTriage() {
    setCard(processingHtml());
    hideNav();
    setTimeout(function () {
      var yellowPage = null;
      for (var i = 0; i < TRIAGE.length; i++) {
        if (TRIAGE[i].tag === 'assessment_complete_yellow') { yellowPage = TRIAGE[i]; break; }
      }
      var url = (yellowPage && evalIf(yellowPage.showIf))
        ? (CFG.triageYellowUrl || '/pages/glp1-result-r2-9rk2')
        : (CFG.triageGreenUrl  || '/pages/glp1-result-r1-4mx7');

      var overlay = document.createElement('div');
      overlay.style.cssText = 'position:fixed;inset:0;background:#f5f6f2;opacity:0;z-index:9999;pointer-events:none;transition:opacity 0.5s ease;';
      document.body.appendChild(overlay);
      void overlay.offsetWidth;
      overlay.style.opacity = '1';
      setTimeout(function() { window.location.href = url; }, 520);
    }, 1800);
  }

  function showHardStop(msg) {
    setCard(
      '<div class="glp1-hardstop">' +
        '<div class="glp1-hardstop-icon">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" width="32" height="32">' +
            '<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>' +
            '<line x1="12" y1="9" x2="12" y2="13"/>' +
            '<line x1="12" y1="17" x2="12.01" y2="17"/>' +
          '</svg>' +
        '</div>' +
        '<h2>We need to pause here</h2>' +
        '<p>' + escHtml(msg || 'This online pathway is not suitable at this time. Please consult a doctor for further guidance.') + '</p>' +
        '<p class="glp1-redirect-note">Redirecting you in a moment…</p>' +
      '</div>'
    );
    hideNav();
    setTimeout(function () {
      window.location.href = CFG.triageRedUrl || '/pages/glp1-result-r3-w3pf';
    }, 3500);
  }

  // ── DOM helpers ─────────────────────────────────────────────────────────
  function escHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function setCard(html) {
    var el = document.getElementById('glp1-card');
    if (el) el.innerHTML = html;
  }

  function hideNav() {
    var nav = document.getElementById('glp1-nav');
    if (nav) nav.style.display = 'none';
  }

  function processingHtml() {
    return '<div class="glp1-processing">' +
      '<div class="glp1-spinner"></div>' +
      '<h2>Reviewing your responses…</h2>' +
      '<p>Just a moment while we prepare your result.</p>' +
    '</div>';
  }

  // ── Rendering ───────────────────────────────────────────────────────────
  function chkBox(on) {
    return '<span class="glp1-opt-chk">' +
      (on ? '<svg viewBox="0 0 10 8" fill="none" stroke="white" stroke-width="2.2"><polyline points="1,4.5 3.5,7 9,1"/></svg>' : '') +
    '</span>';
  }

  function radioHtml(q) {
    var sel  = answers[q.fieldName];
    var html = '<div class="glp1-options" role="radiogroup">';
    (q.options || []).forEach(function (opt) {
      var on = sel === opt.value;
      html += '<div class="glp1-opt' + (on ? ' glp1-opt--on' : '') + '"' +
        ' data-radio="' + q.fieldName + '"' +
        ' data-val="' + escHtml(opt.value) + '"' +
        ' role="radio" tabindex="0" aria-checked="' + on + '">' +
        '<span class="glp1-opt-dot"' + (on ? ' style="border-color:#6d9437;box-shadow:inset 0 0 0 4px #fff,inset 0 0 0 9px #6d9437"' : '') + '></span>' +
        '<span class="glp1-opt-lbl">' + escHtml(opt.label) + '</span>' +
      '</div>';
    });
    html += '</div>';
    return html;
  }

  function checkboxHtml(q) {
    var sel      = answers[q.fieldName] || [];
    var regular  = (q.options || []).filter(function (o) {
      return o.value !== 'none' && o.value !== 'none_of_the_above';
    });
    var noneOpts = (q.options || []).filter(function (o) {
      return o.value === 'none' || o.value === 'none_of_the_above';
    });

    function tile(opt, extraCls) {
      var on  = sel.indexOf(opt.value) !== -1;
      var cls = 'glp1-opt' + (on ? ' glp1-opt--on' : '') + (extraCls ? ' ' + extraCls : '');
      return '<div class="' + cls + '"' +
        ' data-check="' + q.fieldName + '"' +
        ' data-val="' + escHtml(opt.value) + '"' +
        ' role="checkbox" tabindex="0" aria-checked="' + on + '">' +
        chkBox(on) +
        '<span class="glp1-opt-lbl">' + escHtml(opt.label) + '</span>' +
      '</div>';
    }

    var html = '<div class="glp1-options" role="group">';

    if (regular.length > 0) {
      html += '<div class="glp1-opts-grid">';
      regular.forEach(function (opt) { html += tile(opt, ''); });
      html += '</div>';
    }

    if (noneOpts.length > 0) {
      html += '<div class="glp1-or-div">OR</div>';
      noneOpts.forEach(function (opt) { html += tile(opt, 'glp1-opt-full'); });
    }

    html += '</div>';
    return html;
  }

  function questionHtml(q) {
    var hidden = q.showIf && !evalIf(q.showIf);
    var input  = '';

    if      (q.type === 'radio')    { input = radioHtml(q); }
    else if (q.type === 'checkbox') { input = checkboxHtml(q); }
    else if (q.type === 'number') {
      input = '<input class="glp1-input" type="number" inputmode="numeric"' +
        ' data-fi="' + q.fieldName + '"' +
        ' value="' + escHtml(answers[q.fieldName] || '') + '"' +
        ' placeholder="' + escHtml(q.placeholder || '') + '"' +
        ' min="1" max="150">';
    } else if (q.type === 'text') {
      input = '<input class="glp1-input" type="text"' +
        ' data-fi="' + q.fieldName + '"' +
        ' value="' + escHtml(answers[q.fieldName] || '') + '"' +
        ' placeholder="' + escHtml(q.placeholder || '') + '">';
    } else if (q.type === 'textarea') {
      input = '<textarea class="glp1-textarea"' +
        ' data-fi="' + q.fieldName + '"' +
        ' placeholder="' + escHtml(q.placeholder || '') + '">' +
        escHtml(answers[q.fieldName] || '') +
        '</textarea>';
    }

    return '<div class="glp1-q-group' + (hidden ? ' glp1-q-hidden' : '') + '"' +
      ' data-field="' + q.fieldName + '"' +
      ' data-showif="' + escHtml(q.showIf || '') + '">' +
      '<p class="glp1-q-lbl">' + escHtml(q.label) + '</p>' +
      input +
    '</div>';
  }

  function introHtml(page) {
    return '<div class="glp1-intro">' +
      '<div class="glp1-intro-icon">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" width="30" height="30">' +
          '<path d="M9 11l3 3L22 4"/>' +
          '<path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>' +
        '</svg>' +
      '</div>' +
      '<h2 class="glp1-pg-title">' + escHtml(page.title || '') + '</h2>' +
      '<p class="glp1-intro-desc">Answer a few questions about your health history. This takes about 3–5 minutes and is completely confidential.</p>' +
      '<div class="glp1-intro-chips">' +
        '<span class="glp1-chip">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="12" height="12"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>' +
          ' Confidential' +
        '</span>' +
        '<span class="glp1-chip">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="12" height="12"><path d="M12 3l7 3v5c0 5-3.2 8.5-7 10-3.8-1.5-7-5-7-10V6l7-3z"/><path d="M8.8 12l2 2 4.4-5"/></svg>' +
          ' Doctor Reviewed' +
        '</span>' +
        '<span class="glp1-chip">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="12" height="12"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>' +
          ' 3–5 minutes' +
        '</span>' +
      '</div>' +
    '</div>';
  }

  // ── Render a page ───────────────────────────────────────────────────────
  function renderPage(dir) {
    var page    = Q_PAGES[cur()];
    var isIntro = !page.questions || page.questions.length === 0;
    var card    = document.getElementById('glp1-card');
    var back    = document.getElementById('glp1-back');
    var next    = document.getElementById('glp1-next');
    var fill    = document.getElementById('glp1-prog-fill');
    var nav     = document.getElementById('glp1-nav');

    if (nav) nav.style.display = '';

    var html;
    if (isIntro) {
      html = introHtml(page);
    } else {
      var heading = '<h2 class="glp1-pg-title">' + escHtml(page.title || '') + '</h2>';
      if (page.subtitle)    heading += '<p class="glp1-pg-sub">'    + escHtml(page.subtitle)    + '</p>';
      if (page.description) heading += '<p class="glp1-pg-helper">' + escHtml(page.description) + '</p>';
      html = heading + '<div class="glp1-qs">' + (page.questions || []).map(questionHtml).join('') + '</div>';
    }

    var enterCls = dir === 'back' ? 'glp1-enter-left' : 'glp1-enter-right';
    if (card) {
      card.classList.remove('glp1-enter-left', 'glp1-enter-right');
      card.innerHTML = html;
      void card.offsetWidth;
      card.classList.add(enterCls);
    }

    var vis   = visibleList();
    var vi    = vis.indexOf(cur());
    var pct   = vis.length > 0 ? Math.round((vi + 1) / vis.length * 100) : 100;
    if (fill) fill.style.width = pct + '%';

    if (back) back.style.visibility = stack.length > 1 ? 'visible' : 'hidden';
    if (next) next.textContent = isIntro ? 'Start Assessment →' : 'Next →';

    bindInputs();
    refreshConditional();
  }

  // ── Input binding ───────────────────────────────────────────────────────
  function bindInputs() {
    var card = document.getElementById('glp1-card');
    if (!card) return;

    card.querySelectorAll('[data-radio]').forEach(function (el) {
      el.addEventListener('click', onRadioClick);
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onRadioClick.call(el); }
      });
    });

    card.querySelectorAll('[data-check]').forEach(function (el) {
      el.addEventListener('click', onCheckClick);
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onCheckClick.call(el); }
      });
    });

    card.querySelectorAll('[data-fi]').forEach(function (input) {
      input.addEventListener('input', function () {
        answers[this.getAttribute('data-fi')] = this.value;
        refreshConditional();
      });
    });
  }

  function onRadioClick() {
    var field  = this.getAttribute('data-radio');
    var val    = this.getAttribute('data-val');
    answers[field] = val;
    var parent = this.closest('.glp1-options');
    if (parent) {
      parent.querySelectorAll('[data-radio="' + field + '"]').forEach(function (el) {
        var on = el.getAttribute('data-val') === val;
        el.classList.toggle('glp1-opt--on', on);
        el.setAttribute('aria-checked', String(on));
        var dot = el.querySelector('.glp1-opt-dot');
        if (dot) dot.style.cssText = on
          ? 'border-color:#6d9437;box-shadow:inset 0 0 0 4px #fff,inset 0 0 0 9px #6d9437'
          : '';
      });
    }
    refreshConditional();
  }

  function onCheckClick() {
    var field  = this.getAttribute('data-check');
    var val    = this.getAttribute('data-val');
    var isNone = val === 'none' || val === 'none_of_the_above';
    var cur    = Array.isArray(answers[field]) ? answers[field].slice() : [];
    var parent = this.closest('.glp1-options');

    if (isNone) {
      cur = [val];
      if (parent) {
        parent.querySelectorAll('[data-check="' + field + '"]').forEach(function (el) {
          var on = el.getAttribute('data-val') === val;
          el.classList.toggle('glp1-opt--on', on);
          el.setAttribute('aria-checked', String(on));
          syncChk(el, on);
        });
      }
    } else {
      cur = cur.filter(function (v) { return v !== 'none' && v !== 'none_of_the_above'; });
      var idx = cur.indexOf(val);
      if (idx === -1) cur.push(val); else cur.splice(idx, 1);

      if (parent) {
        parent.querySelectorAll('[data-check="' + field + '"]').forEach(function (el) {
          var ev = el.getAttribute('data-val');
          var on = (ev !== 'none' && ev !== 'none_of_the_above') && cur.indexOf(ev) !== -1;
          if (ev === 'none' || ev === 'none_of_the_above') on = false;
          el.classList.toggle('glp1-opt--on', on);
          el.setAttribute('aria-checked', String(on));
          syncChk(el, on);
        });
      }
    }

    answers[field] = cur;
    refreshConditional();
  }

  function syncChk(el, on) {
    var chk = el.querySelector('.glp1-opt-chk');
    if (!chk) return;
    chk.innerHTML = on
      ? '<svg viewBox="0 0 10 8" fill="none" stroke="white" stroke-width="2.2"><polyline points="1,4.5 3.5,7 9,1"/></svg>'
      : '';
  }

  function refreshConditional() {
    var card = document.getElementById('glp1-card');
    if (!card) return;
    card.querySelectorAll('[data-showif]').forEach(function (grp) {
      var expr = grp.getAttribute('data-showif');
      if (!expr) return;
      var vis = evalIf(expr);
      grp.classList.toggle('glp1-q-hidden', !vis);
      if (!vis) {
        var field = grp.getAttribute('data-field');
        if (field) delete answers[field];
      }
    });
  }

  // ── Validation ──────────────────────────────────────────────────────────
  function validate() {
    var page = Q_PAGES[cur()];
    var ok   = true;
    var card = document.getElementById('glp1-card');

    if (card) {
      card.querySelectorAll('.glp1-error').forEach(function (e) { e.remove(); });
      card.querySelectorAll('.glp1-q-group--err').forEach(function (g) { g.classList.remove('glp1-q-group--err'); });
    }

    (page.questions || []).forEach(function (q) {
      if (q.showIf && !evalIf(q.showIf)) return;
      if (!q.required) return;
      var val   = answers[q.fieldName];
      var empty = val === undefined || val === null || val === '' || (Array.isArray(val) && val.length === 0);
      if (!empty) return;

      ok = false;
      if (!card) return;
      var grp = card.querySelector('[data-field="' + q.fieldName + '"]');
      if (!grp) return;
      grp.classList.add('glp1-q-group--err');
      var err = document.createElement('p');
      err.className = 'glp1-error';
      err.textContent = 'Please answer this question to continue.';
      grp.appendChild(err);
    });

    if (!ok && card) {
      var first = card.querySelector('.glp1-q-group--err');
      if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return ok;
  }

  // ── Navigation ──────────────────────────────────────────────────────────
  function goNext() {
    if (busy) return;
    var page    = Q_PAGES[cur()];
    var isIntro = !page.questions || page.questions.length === 0;

    if (!isIntro) {
      if (!validate()) return;
      var stop = getHardStop();
      if (stop) { showHardStop(stop); return; }
    }

    var nxt = nextFrom(cur());
    if (nxt === -1) { doTriage(); return; }

    busy = true;
    var card = document.getElementById('glp1-card');
    if (card) card.classList.add('glp1-exit-left');
    setTimeout(function () {
      if (card) card.classList.remove('glp1-exit-left');
      stack.push(nxt);
      renderPage('next');
      busy = false;
    }, 210);
  }

  function goBack() {
    if (busy || stack.length <= 1) return;
    busy = true;
    var card = document.getElementById('glp1-card');
    if (card) card.classList.add('glp1-exit-right');
    setTimeout(function () {
      if (card) card.classList.remove('glp1-exit-right');
      stack.pop();
      renderPage('back');
      busy = false;
    }, 210);
  }

  // ── Bootstrap ───────────────────────────────────────────────────────────
  function setup(data) {
    Q_PAGES = (data.pages || [])
      .filter(function (p) { return !p._delete && (p.tag || '').indexOf('assessment_complete') !== 0; })
      .sort(function (a, b) { return a.sortOrder - b.sortOrder; });

    TRIAGE = (data.pages || [])
      .filter(function (p) { return !p._delete && (p.tag || '').indexOf('assessment_complete') === 0; })
      .sort(function (a, b) { return a.sortOrder - b.sortOrder; });

    var backBtn = document.getElementById('glp1-back');
    var nextBtn = document.getElementById('glp1-next');
    if (backBtn) backBtn.addEventListener('click', goBack);
    if (nextBtn) nextBtn.addEventListener('click', goNext);

    renderPage('next');
  }

  function init() {
    if (!CFG.formDataUrl) return;
    fetch(CFG.formDataUrl)
      .then(function (r) { return r.json(); })
      .then(setup)
      .catch(function () {
        setCard('<p style="padding:24px;color:#dc2626">Failed to load questionnaire. Please refresh the page.</p>');
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
